/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AIEvidenceResetResponse = {
  mode: AIEvidenceResetResponse.mode;
  /**
   * PDF citations retired by this call, whatever their review state.
   */
  citations_cleared: number;
  excel_references_removed: number;
  /**
   * AI suggestion cards removed by this call (one per suggested field).
   */
  findings_dismissed: number;
};
export namespace AIEvidenceResetResponse {
  export enum mode {
    START_FRESH = 'start_fresh',
    CLEAR_AI_EVIDENCE = 'clear_ai_evidence',
    CLEAR_AI_SUGGESTIONS = 'clear_ai_suggestions',
  }
}
